import _ from 'lodash';

function communiques(state={
    fetching : false,
    putting : false,
    deleting : false,
    posting : false,
    data : [],
}, action) {
    switch(action.type) {
        case 'FETCH_COMMUNIQUES_START':
            return {
                ...state,
                fetching : true,
            }
        case 'FETCH_COMMUNIQUES_SUCCESS':
            return {
                ...state,
                fetching : false,
                data : action.data,
            }
        case 'FETCH_COMMUNIQUES_FAILURE':
            return {
                ...state,
                fetching : false,
            }
        case 'DELETE_COMMUNIQUE_START':
            return {
                ...state,
                deleting : true,
                deleteError : null,
            }
        case 'DELETE_COMMUNIQUE_SUCCESS':
            
            return {
                ...state,
                deleting : false,
                data : _.reject(state.data, (item) => item.id === action.item.id)
            }
        case 'DELETE_COMMUNIQUE_FAILURE':
            return {
                ...state,
                deleting : true,
                deleteError : action.error,
            }
        case 'STORE_COMMUNIQUE_START' :
            return {
                ...state,
                errors : null,
                xhr : action.xhr,
                editedItem : action.editedItem,
                posting : true,
            }
        case 'STORE_COMMUNIQUE_SUCCESS' :
            return {
                ...state,
                xhr : null,
                errors : null,
                progress : 0,
                posting : false,
            }
        case 'STORE_COMMUNIQUE_FAILURE' :
            return {
                ...state,
                errors : action.error.status === 422 ? action.error.response : {},
                progress : 0,
                xhr : null,
                posting : false,
            }
        case 'STORE_COMMUNIQUE_PROGRESS' :
            return {
                ...state,
                progress : action.progress,
            }
        default :
            return state;
    }
}

export default communiques;


/** WEBPACK FOOTER **
 ** ./src/reducers/communiques.js
 **/